import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Tooltip, Tag, Button, Typography, DatePicker } from 'antd';
import { ReloadOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _, { } from 'lodash';
import qs from 'qs';
import { Form } from '@ant-design/compatible';
import TextTruncate from 'react-text-truncate';
import { checkPermission } from '@/utils/permission';
import { cleanObject, stripHtml, isValidDate } from '@/utils/helpers';
import HtmlParser from 'react-html-parser';
import BaseSelect from '@/components/Elements/BaseSelect';
import DirectConsultationResultForm from './DirectConsultationResultForm';
import DirectConsultationDetail from './DirectConsultationDetail';
import { fetchDirectConsultations, fetchDirectConsultation, removeDirectConsultations } from '@/redux/actions/directConsultationActions';
import DynamicTable from '@/components/DynamicTable';
import moment from 'moment';
import PhoneNumberList from '@/components/PhoneNumberList';
import { getCustomerStatusActive } from '@/redux/actions/customerStatusActions';
import CustomerInfoColumn from '@/components/customers/CustomerInfoColumn';

const { RangePicker } = DatePicker;

const { Paragraph } = Typography;
const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/direct-consultations',
        breadcrumbName: 'Lịch tư vấn trực tiếp',
    },
]

class DirectConsultationList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            selectedRowKeys: [],
            loadingDetail: false,
            openDetail: false,
            openUpdateResult: false,
            current_id: null,
            currentItem: null
        }
    }

    componentDidMount() {
        this.loadData();
        this.props.getCustomerStatusActive();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.setState({ isLoading: true });
            this.props.fetchDirectConsultations(query).then(() => {
                this.setState({
                    isLoading: false
                })
            })
        }
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }

        if (name === 'created_at') {
            if (value && value.length > 0) {
                query.created_date_start = moment(value[0]).format('YYYY-MM-DD');
                query.created_date_end = moment(value[1]).format('YYYY-MM-DD');
            } else {
                delete query.created_date_start;
                delete query.created_date_end;
            }
        }
        delete query.created_at;
        query = cleanObject(query);
        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onCustomerDetail(customer_id) {
        this.props.history.push(`/customer/${customer_id}`);
    }

    toggleDetail(openDetail, data = null) {
        this.setState({ openDetail: openDetail, currentItem: data });
    }

    onDetail(id) {
        this.setState({ current_id: id, loadingDetail: true })
        this.props.fetchDirectConsultation(id).then(res => {
            this.setState({ loadingDetail: false })
            this.toggleDetail(true, res);
        })
    }

    loadData() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.setState({ isLoading: true });
        this.props.fetchDirectConsultations(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onCancel() {
        this.props.form.resetFields();
        this.setState({
            openUpdateResult: false,
            isLoading: false,
            selectedRowKeys: []
        })
    }

    onUpdate(id) {
        this.props.fetchDirectConsultation(id).then(res => {
            this.setState({ currentItem: res, openUpdateResult: true })
        })
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
    };

    onRemove() {
        this.props.removeDirectConsultations(this.state.selectedRowKeys).then(() => {
            this.setState({ selectedRowKeys: [] });
            this.loadData();
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }

    render() {
        var { directConsultations, pagination, users, customerStatusActiveList } = this.props;
        var { isLoading,
            currentItem,
            loadingDetail,
            openUpdateResult,
            selectedRowKeys,
            openDetail,
            current_id
        } = this.state;

        var query = qs.parse(this.props.location.search.slice(1));

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        const columns = [
            {
                title: "ID",
                dataIndex: "direct_consultation_id",
                width: "40px",
                align: 'center',
                key: "direct_consultation_id",
                //render: (text, record, index) => index + 1
            },
            {
                title: '#',
                align: 'center',
                key: 'action',
                render: (text, record) => {
                    if (text) {
                        if (checkPermission('direct_consultations', 'detail')) {
                            return (
                                <Tooltip title="Xem chi tiết lịch tư vấn" placement="right">
                                    <div className='color-primary item-action-btn' onClick={() => this.onDetail(record.direct_consultation_id)}>
                                        <EyeOutlined />
                                    </div>
                                </Tooltip>
                            )
                        } else {
                            return (
                                <>
                                    <EyeOutlined style={{ color: '#dedede' }} />
                                </>
                            )
                        }
                    }
                }
            },
            {
                title: 'Khách hàng',
                key: 'customer',
                width: 300,
                render: (_, record) => {

                    const customerRecord = record;

                    const customer = {
                        id: customerRecord?.id,
                        code: customerRecord?.customer_code,
                        full_name: customerRecord?.customer_name,
                        branch_name: customerRecord?.branch_name,
                        conditions: customerRecord?.conditions,
                        customer_source: customerRecord?.customer_source,
                        customer_status: customerRecord?.customer_status,
                        customer_status_color: customerRecord?.customer_status_color,
                        medical_book_number: customerRecord?.medical_book_number
                    }
                    return (
                        <CustomerInfoColumn
                            record={customer}
                            nameField="full_name"          // field tuỳ module
                            idField="id"
                            codeField="code"
                            branchField="branch_name"
                            sourceField="customer_source"
                            statusField="customer_status"
                            statusColorField="customer_status_color"
                        />
                    )
                }
            },
            {
                title: 'Điện thoại',
                dataIndex: 'customer_phone',
                width: '120px',
                key: 'customer_phone',
                render: (text, record) => {
                    return (
                        <PhoneNumberList phones={record.phones} />
                    )
                }
            },
            {
                title: 'Trạng thái',
                width: '150px',
                dataIndex: 'status',
                key: 'status',
                render: (text, record) => {
                    var bgcolor = "#f5b22d";
                    var text2 = "Chưa trả kết quả"
                    if (text === 1) {
                        bgcolor = "green";
                        text2 = "Đã trả kết quả"
                    }
                    if (checkPermission('direct_consultations', 'update_result')) {
                        return (
                            <div>
                                <Tooltip title="Click để cập nhật" placement="right">
                                    <Button icon={<EditOutlined />} style={{ background: bgcolor, color: '#fff', border: 'none' }} onClick={() => this.onUpdate(record.direct_consultation_id)} size='small'>
                                        {text2}
                                    </Button>
                                </Tooltip>
                            </div>
                        )
                    } else {
                        return (
                            <div>
                                <Button style={{ background: bgcolor, color: '#fff', border: 'none' }} size='small'>
                                    {text2}
                                </Button>
                            </div>
                        )
                    }

                }
            },
            {
                title: 'Thời điểm tư vấn',
                dataIndex: 'time_consultant',
                key: 'time_consultant',
                width: '150px',
                render: (text, record) => {
                    return (
                        <div>{isValidDate(text)}</div>
                    )
                }
            },
            {
                title: 'Kết quả tư vấn',
                dataIndex: 'result_content',
                key: 'result_content',
                width: '250px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-all" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={4} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Ghi chú KH',
                dataIndex: 'customer_note',
                key: 'customer_note',
                width: '250px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-all" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={4} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Nhân viên tư vấn',
                dataIndex: 'employee_names',
                key: 'employee_names',
                width: '200px',
                render: (text, record) => {
                    return (
                        <div style={{ wordBreak: "break-all" }}>
                            <Tooltip title={HtmlParser(text)} placement="topLeft">
                                <TextTruncate line={4} truncateText="…" text={stripHtml(text)} />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                title: 'Ngày giao',
                dataIndex: 'created_at',
                key: 'created_at',
                width: '140px',
                sorter: true,
                render: (text, record) => {
                    if (text) {
                        return (
                            <div>{isValidDate(text)}</div>
                        )
                    } else {
                        return (<Tag>N/A</Tag>)
                    }
                }
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Lịch tư vấn trực tiếp" />
                <div>
                    <TableActionBar
                        isShowAddButton={false}
                        isShowDeleteButton={checkPermission('direct_consultations', 'remove')}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={true}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                        placeholderSearch="Mã, tên, 3 số cuối sđt của khách hàng"
                        activeFilter={
                            query.created_date_start

                        }
                        filterColSpan={6}
                        filters={[
                            <RangePicker
                                format="DD/MM/YYYY"
                                placeholder={['Ngày tạo', 'Đến ngày']}
                                className="w-100"
                                onChange={(value) => this.onChangeFilter('created_at', value)}
                                defaultValue={[query.created_date_start ? moment(query.created_date_start, 'YYYY-MM-DD') : null, query.created_date_end ? moment(query.created_date_end, 'YYYY-MM-DD') : null]}
                            />,
                        ]}
                    >
                        <BaseSelect
                            options={users || []}
                            optionValue="user_id"
                            optionLabel="full_name"
                            showSearch
                            placeholder="Nhân viên tư vấn"
                            style={{ width: '200px' }}
                            className="table-button"
                            onChange={(value) => this.onChangeFilter('employee_id', value)}
                            defaultValue={query.employee_id ? parseInt(query.employee_id, 10) : null}
                        />
                        <BaseSelect
                            options={[
                                { value: 1, label: 'Đã trả kết quả' },
                                { value: 0, label: 'Chưa trả kết quả' }
                            ]}
                            placeholder="Trạng thái"
                            style={{ width: '200px' }}
                            className="table-button"
                            onChange={(value) => this.onChangeFilter('status', value)}
                            defaultValue={query.status !== undefined ? parseInt(query.status, 10) : null}
                        />
                        <BaseSelect
                            options={customerStatusActiveList || []}
                            optionValue="id"
                            optionLabel="name"
                            showSearch
                            placeholder="Trạng thái khách hàng"
                            onChange={(value) => this.onChangeFilter('customer_status_id', value)}
                            style={{ width: '200px' }}
                            className="table-button"
                            defaultValue={query.customer_status_id ? parseInt(query.customer_status_id, 10) : null}
                        />
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData()}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>

                <div className='has-custom-column-table-btn'>
                    <DynamicTable
                        rowKey="direct_consultation_id"
                        dataSource={directConsultations || []}
                        columns={columns}
                        isLoading={isLoading}
                        pagination={pagination}
                        rowSelection={rowSelection}
                        moduleKey="direct_consultations"
                        onChangeTable={(pagination, sorter) => this.onChangeTable(pagination, sorter)}
                    />
                </div>

                <DirectConsultationDetail
                    visible={openDetail}
                    currentItem={currentItem}
                    reloadData={() => this.onDetail(current_id)}
                    onCancel={() => this.toggleDetail(false)}
                    reloadList={() => this.loadData()}
                    loadingDetail={loadingDetail}
                />
                <DirectConsultationResultForm
                    visible={openUpdateResult}
                    currentItem={currentItem}
                    reloadData={() => this.loadData()}
                    onCancel={() => this.onCancel()}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        directConsultations: state.directConsultationReducer.items,
        pagination: state.directConsultationReducer.pagination,
        users: state.config.users,
        customerStatusActiveList: state.customerStatusReducer.customerStatusActiveList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        fetchDirectConsultations: (filter) => dispatch(fetchDirectConsultations(filter)),
        fetchDirectConsultation: (id) => dispatch(fetchDirectConsultation(id)),
        removeDirectConsultations: (ids) => dispatch(removeDirectConsultations(ids)),
        getCustomerStatusActive: () => dispatch(getCustomerStatusActive()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'DirectConsultationList' })(DirectConsultationList));

